import { GzAccordionWebComponent } from './component/GzAccordionWebComponent';

export { GzAccordionWebComponent };
